const newsList = document.querySelector('.news-list');
if (newsList) {
  const sendAjaxForNews = (page, category) => {
    axios
      .get(localData.siteURL, {
        params: {
          action: 'getNewsCards',
          id: localData.id,
          lang: localData.lang,
          'page-number': page,
          category,
        },
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        if (response.status === 200) {
          const listInner = newsList.querySelector('.news-list__list');
          if (listInner) {
            listInner.innerHTML = response.data.data.newsHTML;
          }
          const pagination = newsList.querySelector('.pagination');
          if (pagination) {
            pagination.innerHTML = response.data.data.paginationHTML;
          }
          const historyCategories =
            (new URLSearchParams(window.location.search).get('category') || '').split('|') || [];
          const newListItems = newsList.querySelectorAll('.news-list__filter-link');
          if (newListItems) {
            newListItems.forEach((item) => {
              item.classList.toggle('is-active', historyCategories.includes(item.getAttribute('data-category')));
            });
          }
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  attachEvent('.pagination a,.news-list__link a', 'click', (event) => {
    event.preventDefault();
    let pageNumber = event.target.getAttribute('data-page');
    if (!pageNumber) {
      pageNumber = event.target.parentElement.getAttribute('data-page');
    }
    if (pageNumber) {
      let historyCategories = new URLSearchParams(window.location.search).get('category') || '';
      sendAjaxForNews(pageNumber, historyCategories);
      if (historyCategories) {
        historyCategories = `&category=${historyCategories}`;
      }
      window.history.replaceState(
        null,
        null,
        `${window.location.origin}${window.location.pathname}?page-number=${pageNumber}${historyCategories}`,
      );
    }
  });

  attachEvent('.news-list__filter-link', 'click', (event) => {
    event.preventDefault();
    const categoryNumber = event.target.getAttribute('data-category');
    if (event.target.classList.contains('is-active')) {
      event.target.classList.remove('is-active');
      let historyCategories = [];
      if (new URLSearchParams(window.location.search).get('category')) {
        historyCategories = new URLSearchParams(window.location.search).get('category').split('|');
      }
      let categories = [];
      historyCategories.forEach((item) => {
        if (item !== categoryNumber) {
          categories.push(item);
        }
      });
      sendAjaxForNews(1, categories.join('|'));
      if (categories.length > 0) {
        categories = `?category=${categories.join('|')}`;
      }
      window.history.replaceState(null, null, `${window.location.origin}${window.location.pathname}${categories}`);
    } else {
      let historyCategories = [];
      if (new URLSearchParams(window.location.search).get('category')) {
        historyCategories = new URLSearchParams(window.location.search).get('category').split('|');
      }
      if (categoryNumber) {
        historyCategories.push(categoryNumber);
        if (categoryNumber === 'all') {
          sendAjaxForNews(1, `${categoryNumber}`);
          window.history.replaceState(null, null, `${window.location.origin}${window.location.pathname}`);
        } else {
          sendAjaxForNews(1, historyCategories.join('|'));
          window.history.replaceState(
            null,
            null,
            `${window.location.origin}${window.location.pathname}?category=${historyCategories.join('|')}`,
          );
        }
      }
    }
  });
}
